import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { openSuccessionDrawer } from '../../../../actions/successionDrawerActionCreators';

// The shared Succession profile drawer opens by user_name (see
// SuccessionProfileDrawerQueries `getUser(userName:)`), preferring fb_user_name
// like /succession/search does. Participants without a real user (the "Paddy"
// agent, incomplete profiles) return null so callers can render them inert.
export const participantUserName = (participant) =>
  participant?.fb_user_name || participant?.user_name || null;

// Opens the SAME drawer surface used on /succession/search
// (SuccessionDrawerWithListener) via the shared Redux action. Returns true when a
// drawer was opened, false for participants with no real user. A `source` is
// stashed in sessionStorage so the drawer's "Profile View" analytics event can be
// attributed to its entry point (e.g. 'messages').
export default function useProfileDrawer() {
  const dispatch = useDispatch();

  return useCallback((participant, { source = 'messages' } = {}) => {
    const userName = participantUserName(participant);
    if (!userName) return false;

    try {
      sessionStorage.setItem('profileDrawer_source', source);
    } catch (e) {
      // sessionStorage can throw (private mode / disabled) — source is best-effort.
    }

    dispatch(openSuccessionDrawer(userName));
    return true;
  }, [dispatch]);
}
